import React from "react"
import usePlanningCalendar from "app/hooks/usePlanningCalendar"
import { CalendarModes } from "app/hooks/usePlanningCalendar/types"
import { useIntl } from "react-intl"
import useUpdatePathParams from "hooks/useUpdatePathParams"
import ChevronLeft from "components/Icons/ChevronLeft.icon"
import { Link } from "react-router-dom"
import { StyledLeftContainer, StyledBackLink } from "./style"

const LeftComponent: React.FC = () => {
  const { mode, date } = usePlanningCalendar()
  const { messages } = useIntl()
  const { generateMergedPath } = useUpdatePathParams()
  const showBackLink = mode === CalendarModes.DAY
  const backLink = generateMergedPath({ weekday: undefined })

  return (
    <StyledLeftContainer>
      {showBackLink && (
        <StyledBackLink color="inherit" component={Link} to={backLink} startIcon={<ChevronLeft />}>
          {`${messages['general.dates.week']} ${date.isoWeek()}`}
        </StyledBackLink>
      )}
    </StyledLeftContainer>
  )
}

export default LeftComponent
